import { render, staticRenderFns } from "./SpinnerLoading.vue?vue&type=template&id=647df645&scoped=true"
import script from "./SpinnerLoading.vue?vue&type=script&lang=js"
export * from "./SpinnerLoading.vue?vue&type=script&lang=js"
import style0 from "./SpinnerLoading.vue?vue&type=style&index=0&id=647df645&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647df645",
  null
  
)

export default component.exports